export default [
  {
    name: 'JavaScript',
    class: 'devicon-javascript-plain colored',
  },
  {
    name: 'Node.js',
    class: 'devicon-nodejs-plain-wordmark colored',
  },
  {
    name: 'Meteor.js',
    class: 'devicon-meteor-plain-wordmark colored',
  },
  {
    name: 'Vue.js',
    class: 'devicon-vuejs-plain-wordmark colored',
  },
  {
    name: 'Git',
    class: 'devicon-git-plain-wordmark colored',
  },
  {
    name: 'Infrastructure Automation',
    class: 'devicon-heroku-original colored',
  },
  {
    name: 'Automated Testing',
    class: 'devicon-mocha-plain colored',
  },
  {
    name: 'Artificial Intelligence',
    class: 'devicon-python-plain-wordmark colored',
  },
];
